// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__GoBRS","footer":"ModalFilter_footer__1bHx_"};